import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";

function Contact() {
  const form = useRef(); // Pour cibler le formulaire
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    // REMPLACE CES 3 VALEURS PAR LES TIENNES :
    const SERVICE_ID = "service_8oqwdeq";
    const TEMPLATE_ID = "template_3p083lf";
    const PUBLIC_KEY = "R1uiMR48aZjemDHs2";

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
          console.log("Succès !", result.text);
          setSubmitted(true);
          setLoading(false);
      }, (error) => {
          console.log("Erreur...", error.text);
          alert("Oups, l'envoi a échoué. Réessaie plus tard !");
          setLoading(false);
      });
  };

  return (
    <div className="contact-page" style={{ paddingTop: "120px" }}>
      <div className="contact-container">
        <div className="contact-info">
          <h1 className="text-highlight">REJOINS LE QG</h1>
          <p>Une question ? Un partenariat ? Envoie-nous un signal !</p>
          <div className="info-item"><span>📧</span> <p>contact@gamepulsehq.com</p></div>
        </div>

        <div className="contact-form-card">
          {submitted ? (
            <div className="success-message">
              <h3>🚀 Signal envoyé !</h3>
              <p>On te répondra plus vite qu'un speedrun de Mario.</p>
              <button onClick={() => setSubmitted(false)} className="btn-secondary">Renvoyer un message</button>
            </div>
          ) : (
            <form ref={form} onSubmit={sendEmail} className="premium-form">
              <div className="input-row">
                {/* ATTENTION : L'attribut 'name' doit être le même que dans ton template EmailJS */}
                <input type="text" name="from_name" placeholder="Ton Pseudo" required />
                <input type="email" name="reply_to" placeholder="Ton Email" required />
              </div>
              <input type="text" name="subject" placeholder="Sujet" required />
              <textarea name="message" placeholder="Ton message..." rows="6" required></textarea>
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? "CHARGEMENT..." : "ENVOYER LE SIGNAL"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Contact;